import React from 'react';
import { Icon } from '../../Icon';
import { getIconMargin } from './utils';
const getIconProps = ({ icon, iconFill, theme, size, content, }) => (Object.assign({ icon: icon.map, size, fill: iconFill, ariaHidden: true, customTitle: icon.customTitle }, (content ? getIconMargin(theme, icon === null || icon === void 0 ? void 0 : icon.position) : {})));
const IconWrapper = ({ icon, iconFill, theme, size, children, }) => {
    const iconProps = getIconProps({
        icon,
        iconFill,
        theme,
        size,
        content: children,
    });
    if (icon.position === 'right') {
        return (React.createElement(React.Fragment, null,
            children,
            React.createElement(Icon, Object.assign({}, iconProps))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Icon, Object.assign({}, iconProps)),
        children));
};
export const IconWithText = ({ icon, iconFill, theme, size, children, }) => (icon === null || icon === void 0 ? void 0 : icon.map) ? (React.createElement(IconWrapper, { icon: icon, iconFill: iconFill, theme: theme, size: size }, children)) : (React.createElement(React.Fragment, null, children));
//# sourceMappingURL=IconWithText.js.map